import React from "react";
import { useState } from "react";
import Minus from "../SVGs/Minus";
import Plus from "../SVGs/Plus";
import { AnimatePresence, motion } from "framer-motion";
import { FAQsAccordionType } from "../types/FAQsAccordion";
import { CtaButton } from "../Cta/cta-button";
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionTrigger,
  AccordionContent,
} from "@radix-ui/react-accordion";

const FAQsAccordion: React.FC<FAQsAccordionType> = ({
  headline,
  ctaCopy,
  ctaLink,
  ctaUrl,
  faqs,
  onClick,
}) => {
  const [faqsOpen, setFaqsOpen] = useState<string[]>([]);

  const handleOpenFaq = (key: string[]) => {
    setFaqsOpen(key);
  };

  return (
    <div className="faqs--accordion redesign-component">
      <div className="faqs--accordion__wrapper">
        <div className="faqs--accordion__text">
          <h3>{headline}</h3>
          {ctaCopy && (
            <CtaButton
              copy={ctaCopy}
              copySize="bodyRegular"
              isDisabled={false}
              link={ctaLink?.value?.data?.url}
              linkUrl={ctaUrl || null}
              variant="secondaryForest"
              className="cta-headline cta--button-wrapper"
              onClick={onClick}
            />
          )}
        </div>
        <div className="faqs--accordion__accordions">
          <Accordion
            type="multiple"
            value={faqsOpen}
            onValueChange={handleOpenFaq}
          >
            {faqs?.map((item, key) => {
              const isOpen = faqsOpen.includes(key.toString());

              return (
                <AccordionItem
                  value={key.toString()}
                  key={key}
                  className={`faqs--accordion__accordion header4 ${
                    isOpen && "faqs--accordion__accordion--active"
                  }`}
                >
                  <AccordionTrigger asChild className="faqs--trigger">
                    <div className="flex justify-between gap-x-6 md:gap-x-4 sm:gap-x-3">
                      <AccordionHeader
                        className="faqs--accordion__accordion--title flex-1"
                        asChild
                      >
                        <h4>{item?.faq?.value?.data?.question}</h4>
                      </AccordionHeader>
                      <motion.button
                        initial="closed"
                        animate={isOpen ? "open" : "closed"}
                        variants={{
                          open: { rotate: 180 },
                          closed: { rotate: 0 },
                        }}
                        transition={{ duration: 0.2 }}
                        className="faqs--accordion__button"
                        type="button"
                        aria-label="Open"
                      >
                        {isOpen ? <Minus /> : <Plus />}
                      </motion.button>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent
                    forceMount
                    className="faqs--accordion__content-container"
                  >
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial="closed"
                          animate="open"
                          exit="closed"
                          variants={{
                            open: { opacity: 1, height: "auto" },
                            closed: { opacity: 0, height: 0 },
                          }}
                          transition={{
                            duration: 0.2,
                          }}
                          style={{ overflow: "hidden" }}
                          className="faqs--accordion__accordion__content"
                        >
                          <div
                            className="faqs--accordion__accordion__inner-content"
                            dangerouslySetInnerHTML={{
                              __html: item?.faq?.value?.data?.answer,
                            }}
                          />
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        </div>
      </div>
      {ctaCopy && (
        <CtaButton
          copy={ctaCopy}
          copySize="bodyRegular"
          isDisabled={false}
          link={ctaLink?.value?.data?.url}
          linkUrl={ctaUrl || null}
          variant="secondaryForest"
          className="cta-bottom cta--button-wrapper"
          onClick={onClick}
        />
      )}
    </div>
  );
};

export default FAQsAccordion;
